import { IPOForBackend, IPOFromBackend } from '@app/@types/po/poConfig'

const extractControlledOptions = (options: Array<IPOFromBackend>):
  Array<IPOForBackend> => options.filter((option: IPOFromBackend) => option.type !== 'text').map((option: IPOFromBackend) => ({
  number: option.number,
  value: option.value,
}))

export default extractControlledOptions
